import "./Back.css"

export default function Back() {
    return (
        <a className={"detail-back"} href={"/"}></a>
    )
}